/** Períodos [de, ate] inclusive (YYYY-MM-DD) que se interceptam. */
export function periodosStatusInterceptam(de: string, ate: string, periodos: readonly { de: string; ate: string }[]): boolean {
  return periodos.some((p) => de <= p.ate && ate >= p.de);
}

export const MSG_PERIODO_CONFLITO =
  'Este período conflita com outro agendamento. Ajuste as datas ou remova o período existente.';

export const MSG_DIA_UNICO_CONFLITO =
  'Já existe um agendamento para esta data com outro status. Remova o registro anterior ou escolha outra data.';

/** Aviso ao publicar/guardar quando há sobreposição entre períodos em `periodosStatus`. */
export const MSG_AVISO_PERIODOS_SOBREPOSTOS =
  'Os períodos de status programado no calendário estão sobrepostos. Deseja continuar e guardar assim mesmo?';

/** YYYY-MM-DD no fuso local (evita que `toISOString()` em UTC permita “ontem” ou “amanhã” errados). */
export function hojeYmdLocal(): string {
  const d = new Date();
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

/** True se algum par de períodos em `periodosStatus` se sobrepõe (intervalos inclusive). */
export function periodosStatusTemSobreposicao(periodos: readonly { de: string; ate: string }[]): boolean {
  if (periodos.length < 2) return false;
  const norm = periodos.map((p) => {
    const lo = p.de <= p.ate ? p.de : p.ate;
    const hi = p.de <= p.ate ? p.ate : p.de;
    return { lo, hi };
  });
  for (let i = 0; i < norm.length; i++) {
    for (let j = i + 1; j < norm.length; j++) {
      if (norm[i].lo <= norm[j].hi && norm[j].lo <= norm[i].hi) return true;
    }
  }
  return false;
}

export {
  SEGUNDOS_CORTE_DIA_AGENDA_STATUS,
  prioridadeStatusProgramadoNoticia,
  tipoStatusProgramadoDominanteNoDia,
  ymdFromLocalDate,
  ymdReferenciaAgendaStatusLocal,
} from '../../../shared/lib/statusProgramadoNoticia';
